import axios, {type AxiosRequestConfig,type AxiosResponse } from 'axios'
import type {errorResult} from '@/apis/errorResult'
import errorItem from '@/apis/errorItem'
import { findErrorHandler } from '@/apis/errorHandler'
import RequiredLoginException from '@/apis/errorHandler/handler/RequiredLoginException'
import UnauthorizedException from '@/apis/errorHandler/handler/UnauthorizedException'
import { ElMessage } from 'element-plus'
import { useAppContext } from '@/stores/appContext'
import { useI18n } from 'vue-i18n'
import { Configuration } from 'vantis.process';

export const showMessage = (message: string, type: 'info' | 'success' | 'error' | 'warning' = 'success') => {
  ElMessage({
    message: message,
    type: type,
    customClass: "resetMessageIndex"
  });
}
const defaultErrorHandler=(error: any) =>{
  const handler: any = findErrorHandler("DefaultException");
  let errorHandler = new handler("", error.response?.data?.detail ?? (errorItem as any)[error.response.status]);
  if (error.response.status === 401) {
    errorHandler = new RequiredLoginException();
  } else if (error.response.status === 403) {
    errorHandler = new UnauthorizedException();
  }
  errorHandler.handle();
}
//const jwtToken='CfDJ8Nml91iTZNZMhC8WqricK3RPWC-SnMLt9bB7WGQNcM3icso2NRLQOnl0p_8jYnmCEGDopQt3spG_obOWSs-orTp09Wwoi_yKh3thKhSjlSIBzvUx1vVz7YcYUjeNo1xxuEOYy0KU4V_ZEYCupRKjBB3wzecF3HZBXxM86xheem170eaSWAU_G0BfQUkR7ld-P7_4yge1nOILEtbqJZ_VBe5lgPj4d5WJn2jlzz4AZlEy_HRMiUiQ-bUUvBeGGzD3HNh0UT6g66SxrCh7NbUs3sgCXoR0nGX5Ufqh1LTBN3DVRg6ZoF3SaEGMlNCry75GkzlXXOapEhgqTdHZX78atYYTI3IujSv3u32anJ4KWnDZ5doSjvVBXoAEF7CZdMQClOqXvt08MnZz0xfhQUpweC1TwoqNDWDwaaFyPM_ZfKgmcmTiEAvyjkvwqOkMJqvJ3qjO6VnarLbfpMhJSltKjGMXQ_gaY48tmqHsHMuZWyHSOZsOd3_3AbCiAAdaM8CWw6-JuMbVr3m9os9NSB3glcmFxbOiQksc9Ht7QlUWE414RSFbJeKe2GNKWeyoKn_-4UQgWXuMRFRTcG9oUwKl2qx0mDmVdNBZPBesvE1tWZcT';
//后期做成插件


let initialized=false;
export const initialize=()=>{
  if(initialized){
    return;
  }
  initialized=true;
  const appContext=useAppContext();
  const {t}=useI18n();
  initializeAxios(appContext,t);
  Configuration.globalConfiguration={axiosInstance:axios};
   appContext.$subscribe((mutation,state)=>{
     appendApiConfig(appContext);
  })
}
const appendApiConfig=(appContext:any)=>{
  axios.defaults.headers["tenantId"]=appContext.tenantId||'';//'DEMO_HR_7.5_Dev_FlowEngine';
  axios.defaults.headers["Authorization"]=appContext.accessToken||'';
  axios.defaults.baseURL = appContext.backendUrl||'';
}
const initializeAxios=(appContext:any, t:any)=>{
  axios.defaults.headers.post['Content-Type'] = "application/json";
  axios.defaults.timeout = 120000;
  axios.defaults.timeoutErrorMessage = "TIME OUT!";
  axios.defaults.withCredentials = true;
  axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
  axios.defaults.headers.post['Access-Control-Allow-Credentials'] = 'true';
  appendApiConfig(appContext);
  /*todo:这里改成成功失败都调用同一个方法.
              * 错误处理程序可以通过error.response.config来指定.
              * 如果不指定的话就用默认的.
              * 需要新增一个类来管理错误处理程序.
              * 类需要addOrUpdate和getHandlerByErrorCode方法.
              *  */

   axios.interceptors.response.use((res: AxiosResponse) => {
    //httpClient.handelError(res);
    return res;
  }, (error: any) => {
    //httpClient.handelError(error.response);
    const responseConfig: AxiosRequestConfig = error?.response?.config;
    //不忽略全局错误处理,并且response以及response.data不为空
    if (!responseConfig?.ignoreGlobalExceptionHandling && error.response && error.response.data) {
      if (error.response.data as errorResult) {
        const errorResult = error.response.data as errorResult;
        if (errorResult.errorCode.indexOf('`') > -1) {
          errorResult.errorCode = errorResult.errorCode.substring(0, errorResult.errorCode.indexOf('`'))
        }
        const handler = findErrorHandler(errorResult.errorCode);
        const options = responseConfig.errorOptionList?.find(p => p.handlerCode.toLocaleLowerCase() === errorResult.errorCode.toLocaleLowerCase());
        const errorMessageKey = options?.messageKey;
        let errorMessage = (options?.message || errorResult.detail) || errorResult.errors;
        if (responseConfig.apiActionName && (!responseConfig.apiActionName.name || !responseConfig.apiActionName.nameKey)) {
          errorMessage = (responseConfig.apiActionName.name || t(responseConfig.apiActionName.nameKey!)) + ":" + errorMessage;
        }
        const errorHandler = new handler(errorMessageKey, errorMessage);
        errorHandler.handle();
      } else {
        defaultErrorHandler(error);
      }
    } else if (error.response && (error.response.data?.detail || typeof error.response.data == "string")) {
      defaultErrorHandler(error);
    }

    if (error.request) {
      if (error.request.readyState == 4 && error.request.status == 0) {
        showMessage('响应超时!', 'warning');
      }
    }


    if (error.response) {
      if (error.response.data) {
        return Promise.reject(error.response.data)
      } else {
        return Promise.reject(error)
      }
    }
    // 该返回的数据则是axios.catch(err)中接收的数据
    return Promise.reject(error)
  })

}